import { ACTION_TYPES, MAX_SCREENSHOTS_RESULTS } from '~/core/constants'
import { fetchScreenshots } from '~/services/screenshots'
import { selectHasMorePages, selectLastScreenshotsPageIndex, getFetchingInProgress } from '~/selectors/screenshots'
import { batch } from 'react-redux'

const { SCREENSHOTS } = ACTION_TYPES

const fetchedScreenshots = payload => ({
  type: SCREENSHOTS.FETCHED_SCREENSHOTS,
  payload
})

export const setFetchingInProgress = ({ sessionId, value }) => ({
  type: SCREENSHOTS.FETCHING_IN_PROGRESS,
  payload: { sessionId, value }
})

export const purgeScreenshotData = sessionId => ({
  type: SCREENSHOTS.PURGE_SCREENSHOT_DATA,
  payload: { sessionId }
})

export const getScreenshots = sessionId => async (
  dispatch,
  getState
) => {
  const fetchingInProgress = getFetchingInProgress(sessionId)(getState())

  if (fetchingInProgress) {
    return
  }

  const hasMoreScreenshots = selectHasMorePages(sessionId)(getState())
  const lastScreenshotsPageIndex = selectLastScreenshotsPageIndex(sessionId)(getState())

  if (!hasMoreScreenshots) {
    return
  }

  dispatch(setFetchingInProgress({ sessionId, value: true }))

  const response = await fetchScreenshots(
    sessionId,
    lastScreenshotsPageIndex,
    MAX_SCREENSHOTS_RESULTS
  )

  batch(() => {
    dispatch(setFetchingInProgress({ sessionId, value: false }))
    dispatch(fetchedScreenshots(response))
  })
}

export const setSelectedScreenshotId = ({ sessionId, screenshotId }) => ({
  type: SCREENSHOTS.SET_SELECTED_SCREENSHOT,
  payload: { sessionId, screenshotId }
})
